import React, { useContext } from "react";
import { ErrorBoundary, Page, hasActiveFilters } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/signaturesSlice";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { useGetSignaturesQuery } from "../services/signatures.api";
import { getQueryStatus } from "../utils";
import Filter from "./filter/Filter";
import SignatureTable from "./SignatureTable";
const Signatures = () => {
    var _a;
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data: fetchedData, isLoading, isFetching, isError, error, } = useGetSignaturesQuery({
        filter,
        sort,
        pagination,
        ui_id: reportId,
    });
    const data = fetchedData
        ? fetchedData
        : {
            signatures: [],
            match_count: 0,
        };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Signatures", details: [
                formatCount((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.signatures) !== null && _a !== void 0 ? _a : 0, "Signature"),
            ] }),
        React.createElement(Page.Filters, { found: {
                id: "signatures-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(SignatureTable
            // Force rerender of the table to collapse expanded rows when filter/pagination/sort changes
            , { 
                // Force rerender of the table to collapse expanded rows when filter/pagination/sort changes
                key: `${JSON.stringify(filter)} ${JSON.stringify(sort)} ${JSON.stringify(pagination)}`, signatures: data.signatures, sort: sort, searchRegex: filter.identity, filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => dispatch(filterUpdated(initFilter)),
                }, onSortChange: (sort) => dispatch(sortUpdated(sort)), status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data: fetchedData,
                }), itemCount: data.match_count, pagination: pagination, onPaginationChange: (pagination) => dispatch(paginationUpdated(pagination)) }))));
};
const SignaturesPage = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorBoundary, { key: "signatures" },
            React.createElement(Signatures, null))));
};
export default SignaturesPage;
//# sourceMappingURL=Signatures.js.map